export default __webpack_public_path__ + "static/media/binanceIcon.cb6b375e.jpeg";